/**
 * The accounts-payable side of inventory: whether a vendor has been paid for
 * a cost line, and what kind of cost line it is. Separate from `payments` in
 * orders.ts, which is the customer-side (sales) money — this is what the
 * shop owes out, not what it took in.
 */
export const VENDOR_PAYMENT_STATUSES = ['unpaid', 'invoiced', 'paid'];
/**
 * `purchase` is the cost of acquiring the item itself (recorded automatically
 * from intake for serialized units, or entered directly for a product-level
 * purchase). `addon` is an extra cost added to a specific serialized unit
 * after the fact — e.g. a part or accessory bundled onto one IMEI — which
 * folds into that unit's cost basis. `purchase` rows never do; see
 * `inventory_costs` in apps/api/src/db/schema/inventory.ts for why.
 */
export const INVENTORY_COST_KINDS = ['purchase', 'addon'];
/** The supplier invoice or receipt attached to a cost line — one per row, upload replaces. */
export const MAX_COST_DOCUMENT_BYTES = 10 * 1024 * 1024;
export const ALLOWED_COST_DOCUMENT_TYPES = [
    'application/pdf',
    'image/jpeg',
    'image/png',
    'image/webp',
];
//# sourceMappingURL=purchasing.js.map